"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createJaqlElement = exports.JaqlElement = void 0;
const base_js_1 = require("./base.js");
const utils_js_1 = require("../utils.js");
const types_js_1 = require("./types.js");
/**
 * This implementation wraps metadata for a JAQL query. The metadata could be
 * for a dimension, measure, or filter. We do little to no interpretation of
 * the JAQL as it is designed to be "passed through" to the query execution
 * step.
 *
 * This will typically be used for JAQL metadata that is coming from a Sisense
 * instance and is assumed to be correct (e.g. dashboard widget, NLQ
 * suggestion).
 *
 * @param item - the metadata item in a JAQL query
 * @param type - the data type of the dimension
 * @internal
 */
class JaqlElement extends base_js_1.DimensionalElement {
    constructor(item, type) {
        var _a;
        super((_a = item.jaql.title) !== null && _a !== void 0 ? _a : '', type);
        this.expression = (item.jaql.dim || item.jaql.formula);
        this.metadataItem = item;
        if (item.jaql.agg) {
            this.aggregation = item.jaql.agg;
        }
        else {
            delete this.aggregation;
        }
        if (item.jaql.formula) {
            this.formula = item.jaql.formula;
        }
        else {
            delete this.formula;
        }
        if (item.jaql.sort) {
            this.sortType = (0, utils_js_1.getSortType)(item.jaql.sort);
        }
        else {
            delete this.sortType;
        }
        this.skipValidation = true;
    }
    get id() {
        return this.expression;
    }
    jaql(nested) {
        return nested === true ? this.metadataItem.jaql : this.metadataItem;
    }
}
exports.JaqlElement = JaqlElement;
const toMetadataType = {
    text: types_js_1.MetadataTypes.TextAttribute,
    numeric: types_js_1.MetadataTypes.NumericAttribute,
    datetime: types_js_1.MetadataTypes.DateLevel,
};
/**
 * Create a JaqlElement from a MetadataItem
 *
 * @param item - the metadata item in a JAQL query
 * @returns a JaqlElement
 * @internal
 */
function createJaqlElement(item) {
    var _a;
    // TODO: measures with a "formula" may not have a datatype. force this to be numeric because aggregations
    // will always be of type number. check if there is a more correct way to do this
    return new JaqlElement(item, (_a = toMetadataType[item.jaql.datatype]) !== null && _a !== void 0 ? _a : 'numeric');
}
exports.createJaqlElement = createJaqlElement;
